<mat-tab-group>
  <mat-tab label="Cut-Point Analysis"> <card [title]="'Report Analysis'" class="mb-0">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
  
    <mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
      <ng-container matColumnDef="analyteName">
        <mat-header-cell *matHeaderCellDef> Analyte Name </mat-header-cell>>
        <mat-cell  *matCellDef="let element"><a [routerLink]="[getUrl(element.analysisType), element.analysisId, element.userId, {type: 'previous'}]">{{element.analyteNames}} </a></mat-cell>
      </ng-container>
   
      <ng-container matColumnDef="analysisDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Analysis Date </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.analysisDate }} </mat-cell>
      </ng-container>
   
      <ng-container matColumnDef="projectNames">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
        <mat-cell *matCellDef="let element"><a [routerLink]="[getUrl(element.analysisType), element.analysisId, element.userId]">{{element.projectCode}}</a></mat-cell>
      </ng-container>
      <ng-container matColumnDef="studyCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Study </mat-header-cell>
        <mat-cell *matCellDef="let element"><a [routerLink]="[getUrl(element.analysisType), element.analysisId, element.userId]">{{element.studyCode}}</a></mat-cell>
      </ng-container>
      <ng-container matColumnDef="analysisType">
        <mat-header-cell *matHeaderCellDef> Analysis Type </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.analysisTypeDisplay}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="assayType">
        <mat-header-cell *matHeaderCellDef> Assay Type </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.assayType}} </mat-cell>
      </ng-container>
  
      <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableColumns;"></mat-row>
    </mat-table>
    <mat-paginator #RApaginator [length]="reportAnalysis.length" [pageSizeOptions]="[ 10, 20]"  showFirstLastButtons></mat-paginator>
  </card> </mat-tab>
</mat-tab-group>








